import http from '../http'

// 复检 我管理中选人之后派发
export const createReinspection = data => {
    return http('/app-api/inspection/recheck-info/create', 'post', data)
}

// 修改复检流程状态
// 检验检测流程状态
export const  updateRecheckInfoStatus = data => {
    return http(`/app-api/inspection/recheck-info/update`, 'post', data)
}
/**
 * 复检info表  获取检验结论数据  根据复检Id查询infoId
 */
export const  getReinspectionInfo = data => {
    return http(`/app-api/inspection/recheck-info/get?id=${data.id}`, 'get', data)
}
/**
 * 根据infoId查询复检Id
 */
 export const  getRecheckByInfoId = data => {
    return http(`/app-api/inspection/recheck-info/getRecheckByInfoId?id=${data.id}`, 'get', data)
}
// app-api/inspection/info-problem/getRecheckResultCount?recheckId
/**
 * 发布页 审核页 签发页 项目合格数据
 */
export const  getRecheckResultCount = data => {
    return http(`/app-api/inspection/info-problem/getRecheckResultCount?recheckId=${data.recheckId}`, 'get', data)
}

//获取复检的保存草稿历史记录 发布停止时再次进去获取之前的拍照信息
export const  getDraftHandleHistory = data => {
    return http(`/app-api/inspection/info-result-history/getDraftHistoryByRecheck?recheckId=${data.recheckId}`, 'get', data)
}



